module.exports = __webpack_public_path__ + "static/img/aiNoData.a7fd7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aiNoData.png
// module id = ABGp
// module chunks = 1